import Index from './index.vue'

export default [
  {
    path: 'expenses',
    name: 'reports-expenses',
    component: Index,
    title: 'Expenses',
  },
]
